// "no-unknown-property" is broken so disabling it...
/* eslint-disable react/no-unknown-property */
// I don't want to deal with the complexity of GlueInputfield so here's a custom one
import React, { useState } from 'react'
import { makeStyles, InputBase, Typography, Tooltip } from '@material-ui/core'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import InfoIcon from '@material-ui/icons/Info'
import GlueIcon from '../glueos-components/glue-icon'

const getBgColor = (theme, props) => {
  if (props.error) {
    return theme.palette.input.backgroundError
  } else if (props?.active) {
    return theme.palette.input.backgroundActive
  } else {
    return theme.palette.input.background
  }
}

const getBorderColor = (theme, props) => {
  if (props.error) {
    return theme.palette.input.error
  } else if (props?.active) {
    return theme.palette.input.active
  } else {
    return theme.palette.input.main
  }
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: ({ width }) => width ?? theme.custom.inputField.defaultWidth,
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing('xs')
  },

  label: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing('m'),
    overflow: 'hidden',

    '&> p': {
      whiteSpace: 'nowrap',
      display: 'block',
      textOverflow: 'ellipsis'
    }
  },

  labelRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing('s')
  },

  errorText: {
    color: theme.palette.input.error,
    opacity: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'block',
    textOverflow: 'ellipsis'
  },

  inputArea: {
    position: 'relative',
    height: 'fit-content',
    minHeight: theme.custom.inputField.height,
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '4px',
    background: (props) => getBgColor(theme, props)
  },

  border: {
    pointerEvents: 'none',
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: theme.custom.inputField.borderThickness,
    borderColor: (props) => getBorderColor(theme, props)
  },

  input: {
    width: '100%',
    padding: `calc((${theme.custom.inputField.height} - ${theme.custom.inputField.lineHeight}) / 2) ${theme.spacing('s')}`
  },

  inputMultiline: {
    overflow: 'hidden'
  },

  clearButton: {
    cursor: 'pointer'
  },

  tooltip: {
    width: theme.custom.inputField.tooltipWidth,
    height: 'fit-content',
    top: 0
  }
}), { name: 'MuiGlueInputfield' })

const InputField = (props) => {
  const [ active, setActive ] = useState(false)
  const [ passwordVisible, setPasswordVisible ] = useState(false)
  const classes = useStyles({ ...props, active })

  const setValue = (newValue) => {
    if (props.onChange) {
      props.onChange(newValue)
    }
  }

  const onSetFocus = (value) => {
    setActive(value)
    if (window.vuplex) {
      window.vuplex.postMessage({
        topic: 'Enable textfield',
        args: JSON.stringify({ value: value })
      })
    }
  }

  const handleKeyEventEnter = (event) => {
    if (props.onSubmitKey && event.key === 'Enter') {
      props.onSubmitKey()
    }
  }

  const inputType = !props.type || (props.type === 'password' && passwordVisible) ? 'text' : props.type

  return (
    <div className={classes.root}>
      <div className={classes.label}>
        <p>{props.label}</p>
        <div className={classes.labelRight}>
          <Typography variant='overline' className={classes.errorText}>{props.error}</Typography>
          {props.info && (
            <Tooltip classes= title={props.info} arrow placement='top'>
              <InfoIcon />
            </Tooltip>
          )}
        </div>
      </div>
      <div className={classes.inputArea}>
        <div className={classes.border} />
        {props.type && props.type === 'password' && (
          <div className={classes.clearButton} onPointerDown={(e) => setPasswordVisible(old => !old)}>
            <GlueIcon>
              { passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon /> }
            </GlueIcon>
          </div>
        )}
        <InputBase
          classes=
          type={inputType}
          multiline={props.multiline}
          maxRows={2}
          placeholder={props.placeholder}
          defaultValue={props.defaultValue}
          value={props.value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={(e) => onSetFocus(true)}
          onBlur={(e) => onSetFocus(false)}
          onKeyUp={e => handleKeyEventEnter(e)}
        />
        {!!props.value && (
          <div className={classes.clearButton} onPointerDown={(e) => setValue('')}>
            <GlueIcon>
              <CloseOutlinedIcon />
            </GlueIcon>
          </div>
        )}
      </div>
    </div>
  )
}

export default InputField
